module.exports = __webpack_public_path__ + "static/favicon/mstile-150x150.png";